import { UseFormReturn } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormDescription,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { PhoneInput } from '@/components/ui/phone-input';

interface BasicInfoFormProps {
  form: UseFormReturn<any>;
  user: any;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function BasicInfoForm({ form, user, onNameChange }: BasicInfoFormProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nome</FormLabel>
            <FormControl>
              <Input {...field} onChange={onNameChange} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input {...field} disabled />
            </FormControl>
            <FormDescription>
              Email não pode ser alterado
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Telefone</FormLabel>
            <FormControl>
              <PhoneInput {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="whatsapp"
        render={({ field }) => (
          <FormItem>
            <FormLabel>WhatsApp</FormLabel>
            <FormControl>
              <PhoneInput {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="instagram"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Instagram</FormLabel>
            <FormControl>
              <Input {...field} placeholder="@seuinstagram" />
            </FormControl>
            <FormDescription>
              Digite apenas o nome de usuário, sem o '@' ou o link completo
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="creci"
        render={({ field }) => (
          <FormItem>
            <FormLabel>CRECI</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="slug"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Link da Vitrine</FormLabel>
            <FormControl>
              <div className="flex items-center">
                <span className="text-sm text-muted-foreground mr-2">imoveis.vitrineturbo.com/</span>
                <Input {...field} placeholder="seu-nome" />
              </div>
            </FormControl>
            <FormDescription>
              URL amigável para sua vitrine pública
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}